import { ensureCustomDocuments } from '@/lib/raspadinha-campaigns/custom-documents'
import type { RaspadinhaCampaign } from '@/types/raspadinha-campaign'
import type { RaspadinhaPublicRegulationDocument } from '@/types/raspadinha-public-regulation-document'

export const RASPADINHA_PUBLIC_REGULATION_DOC_ID = 'regulation'
export const RASPADINHA_PUBLIC_COOKIE_POLICY_DOC_ID = 'cookie-policy'

type RegulationDocumentSource = Pick<
  RaspadinhaCampaign,
  | 'regulation_pdf_url'
  | 'regulation_pdf_name'
  | 'cookie_policy_pdf_url'
  | 'cookie_policy_pdf_name'
  | 'custom_documents'
>

export function collectRaspadinhaPublicRegulationDocuments(
  campaign: RegulationDocumentSource
): RaspadinhaPublicRegulationDocument[] {
  const documents: RaspadinhaPublicRegulationDocument[] = []

  if (campaign.regulation_pdf_url.trim()) {
    documents.push({
      id: RASPADINHA_PUBLIC_REGULATION_DOC_ID,
      title: 'Regulamento da campanha',
      pdf_url: campaign.regulation_pdf_url,
      pdf_name: campaign.regulation_pdf_name.trim() || 'regulamento.pdf',
    })
  }

  if (campaign.cookie_policy_pdf_url.trim()) {
    documents.push({
      id: RASPADINHA_PUBLIC_COOKIE_POLICY_DOC_ID,
      title: 'Políticas de Cookies',
      pdf_url: campaign.cookie_policy_pdf_url,
      pdf_name: campaign.cookie_policy_pdf_name.trim() || 'politica-de-cookies.pdf',
    })
  }

  for (const document of ensureCustomDocuments(campaign.custom_documents)) {
    if (!document.pdf_url.trim()) {
      continue
    }

    documents.push({
      id: document.id,
      title: document.title.trim() || document.pdf_name.trim() || 'Documento',
      pdf_url: document.pdf_url,
      pdf_name: document.pdf_name.trim() || 'documento.pdf',
    })
  }

  return documents
}
